module.exports = __webpack_public_path__ + "img/Info-Circle.1367cf7e.svg";